import styled from "@emotion/styled";
import { Colors } from '../../../../../colors';
import { Grid } from '@mui/material';
import { headerHeight } from '../header/header.styled';

export const SideBarStyled = {
  Container: styled(Grid)<any>`
    min-height: calc(100vh - ${headerHeight});
    background: ${Colors.LightGrey};
    padding-top: 20px;
    position: ${(props: any) => props.isHamburgerClicked ? 'absolute' : 'inherit'};
    left: 0;
    top: 0;
    z-index: 100;
  `,
  ContainerTBAlert: styled.div<any>`
    padding-bottom: 20px;
    margin-left: 20px;
    margin-right: 20px;
  `,
  ContainerContent: styled.div<any>`
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column
  `,
  ContainerButtons: styled.div<any>`
   
  `,
};
